// extracted by mini-css-extract-plugin
module.exports = {"component":"repeater-matrix-type-images_component_17enk","image":"repeater-matrix-type-images_image_FqdHn","is-portrait":"repeater-matrix-type-images_is-portrait_2AqeN"};